import { AdvancedFilterDataSchema } from "@redotech/redo-model/views/views";
import * as z from "zod/v4";

export const createBalanceTransactionExport = {
  name: "createBalanceTransactionExport" as const,
  input: z.object({
    filters: z.array(AdvancedFilterDataSchema),
    sendToEmail: z.string().email().optional(),
  }),
  output: z.object({ exportId: z.string(), fileUrl: z.string().optional() }),
};
